import { useTranslationTerm } from 'utils/helper';

export const term = useTranslationTerm('_dashboard._manage_account');
